/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUserMultipassToken201ResponseAllOfData } from './CreateUserMultipassToken201ResponseAllOfData';
import {
    CreateUserMultipassToken201ResponseAllOfDataFromJSON,
    CreateUserMultipassToken201ResponseAllOfDataFromJSONTyped,
    CreateUserMultipassToken201ResponseAllOfDataToJSON,
} from './CreateUserMultipassToken201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateUserMultipassToken201Response
 */
export interface CreateUserMultipassToken201Response {
    /**
     * 
     * @type {CreateUserMultipassToken201ResponseAllOfData}
     * @memberof CreateUserMultipassToken201Response
     */
    data: CreateUserMultipassToken201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateUserMultipassToken201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateUserMultipassToken201Response interface.
 */
export function instanceOfCreateUserMultipassToken201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateUserMultipassToken201ResponseFromJSON(json: any): CreateUserMultipassToken201Response {
    return CreateUserMultipassToken201ResponseFromJSONTyped(json, false);
}

export function CreateUserMultipassToken201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserMultipassToken201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateUserMultipassToken201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateUserMultipassToken201ResponseToJSON(value?: CreateUserMultipassToken201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateUserMultipassToken201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

